/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as PoolRouteImport } from "./routes/pool"
import { Route as QrsEvseIdRouteImport } from "./routes/qrs/$evseId"
import { Route as QrsEvseIdIndexRouteImport } from "./routes/qrs/$evseId/index"
import { Route as QrsEvseIdSpotsRouteImport } from "./routes/qrs/$evseId/spots"

const PoolRoute = PoolRouteImport.update({
  id: "/pool",
  path: "/pool",
  getParentRoute: () => rootRouteImport,
} as any)
const QrsEvseIdRoute = QrsEvseIdRouteImport.update({
  id: "/qrs/$evseId",
  path: "/qrs/$evseId",
  getParentRoute: () => rootRouteImport,
} as any)
const QrsEvseIdIndexRoute = QrsEvseIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => QrsEvseIdRoute,
} as any)
const QrsEvseIdSpotsRoute = QrsEvseIdSpotsRouteImport.update({
  id: "/spots",
  path: "/spots",
  getParentRoute: () => QrsEvseIdRoute,
} as any)

export interface FileRoutesByFullPath {
  "/pool": typeof PoolRoute
  "/qrs/$evseId": typeof QrsEvseIdRouteWithChildren
  "/qrs/$evseId/spots": typeof QrsEvseIdSpotsRoute
  "/qrs/$evseId/": typeof QrsEvseIdIndexRoute
}
export interface FileRoutesByTo {
  "/pool": typeof PoolRoute
  "/qrs/$evseId/spots": typeof QrsEvseIdSpotsRoute
  "/qrs/$evseId": typeof QrsEvseIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/pool": typeof PoolRoute
  "/qrs/$evseId": typeof QrsEvseIdRouteWithChildren
  "/qrs/$evseId/spots": typeof QrsEvseIdSpotsRoute
  "/qrs/$evseId/": typeof QrsEvseIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: "/pool" | "/qrs/$evseId" | "/qrs/$evseId/spots" | "/qrs/$evseId/"
  fileRoutesByTo: FileRoutesByTo
  to: "/pool" | "/qrs/$evseId/spots" | "/qrs/$evseId"
  id:
    | "__root__"
    | "/pool"
    | "/qrs/$evseId"
    | "/qrs/$evseId/spots"
    | "/qrs/$evseId/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PoolRoute: typeof PoolRoute
  QrsEvseIdRoute: typeof QrsEvseIdRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/pool": {
      id: "/pool"
      path: "/pool"
      fullPath: "/pool"
      preLoaderRoute: typeof PoolRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/qrs/$evseId": {
      id: "/qrs/$evseId"
      path: "/qrs/$evseId"
      fullPath: "/qrs/$evseId"
      preLoaderRoute: typeof QrsEvseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/qrs/$evseId/": {
      id: "/qrs/$evseId/"
      path: "/"
      fullPath: "/qrs/$evseId/"
      preLoaderRoute: typeof QrsEvseIdIndexRouteImport
      parentRoute: typeof QrsEvseIdRoute
    }
    "/qrs/$evseId/spots": {
      id: "/qrs/$evseId/spots"
      path: "/spots"
      fullPath: "/qrs/$evseId/spots"
      preLoaderRoute: typeof QrsEvseIdSpotsRouteImport
      parentRoute: typeof QrsEvseIdRoute
    }
  }
}

interface QrsEvseIdRouteChildren {
  QrsEvseIdSpotsRoute: typeof QrsEvseIdSpotsRoute
  QrsEvseIdIndexRoute: typeof QrsEvseIdIndexRoute
}

const QrsEvseIdRouteChildren: QrsEvseIdRouteChildren = {
  QrsEvseIdSpotsRoute: QrsEvseIdSpotsRoute,
  QrsEvseIdIndexRoute: QrsEvseIdIndexRoute,
}

const QrsEvseIdRouteWithChildren = QrsEvseIdRoute._addFileChildren(
  QrsEvseIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PoolRoute: PoolRoute,
  QrsEvseIdRoute: QrsEvseIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
